import * as React from 'react'

import { Chevron, Icon, useToggle } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type Leave from 'modules/timeoff/store/models/Leave'

import Item from './Item'
import styles from './index.module.scss'

const cx = classNames.bind(styles)
interface Props {
  leave?: Leave
  readonly: boolean
  contractVersions: ContractVersions
}

const DocumentList = ({ leave, readonly = false, contractVersions }: Props) => {
  const [open, toggle] = useToggle()
  const documents = leave ? leave.documents : []

  if (!documents.length) {
    return null
  }

  return (
    <div
      className={cx('documentList', {
        open,
      })}
    >
      <div onClick={toggle(!open)} className={styles.header}>
        <div className={styles.name}>
          <Icon.Large icon="documents" />
          <span className={styles.nameContent}>
            {i18n.t('time_off.document_list.title', {
              count: documents.length,
            })}
          </span>
        </div>
        <Chevron direction={open ? 'up' : 'down'} type="terciary" />
      </div>
      {open &&
        documents.map((document) => (
          <Item
            key={document.attributes.id}
            readonly={readonly}
            document={document}
            contractVersions={contractVersions}
          />
        ))}
    </div>
  )
}

export default observer(DocumentList)
